import DrawerBase from "@mui/material/Drawer";

export const Drawer = DrawerBase;
